import { apiUrl, authHeaders } from './auth';

export interface MedicalExpenseType {
    id: number;
    code: string;
    name: string;
    is_active: boolean;
}

export interface PatientVerificationPayload {
    medical_expenses: number[];
    medical_expenses_other?: string;
    verifier_name: string;
    // Optional YYYY-MM-DD; backend defaults to today when omitted.
    verification_date?: string;
}

export const fetchPatientForVerification = async (id: number) => {
    const headers = authHeaders();
    const resp = await fetch(`${apiUrl}/admin/patients/${id}`, {
        method: 'GET',
        headers,
    });
    if (!resp.ok) {
        throw new Error('Error fetching patient');
    }
    return resp.json();
};

// `patientId` narrows the checklist to the expenses that apply to this
// patient's campaign generation and medical reason, matching legacy. Omitting
// it returns every active expense type.
export const fetchMedicalExpenseTypes = async (
    patientId?: number
): Promise<MedicalExpenseType[]> => {
    const headers = authHeaders();
    const query = patientId ? `?patient=${patientId}` : '';
    const resp = await fetch(`${apiUrl}/admin/medicalExpenseTypes${query}`, {
        method: 'GET',
        headers,
    });
    if (!resp.ok) {
        throw new Error('Error fetching medical expense types');
    }
    return resp.json();
};

export const submitPatientVerification = async (
    id: number,
    payload: PatientVerificationPayload
) => {
    const headers = authHeaders();
    const resp = await fetch(`${apiUrl}/admin/patients/${id}/verify`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(payload),
    });
    if (!resp.ok) {
        const body = await resp.json().catch(() => ({}));
        throw new Error(body.detail || 'Error submitting verification');
    }
    return resp.json();
};
